(function () {
  var CROSSFADE_LEAD = 0.45;
  var CROSSFADE_MS = 450;

  function tryPlay(video) {
    if (!video) return;

    video.muted = true;
    video.defaultMuted = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {});
    }
  }

  function isVideoVisible(video) {
    var rect = video.getBoundingClientRect();
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < viewportHeight * 0.9 && rect.bottom > viewportHeight * 0.1;
  }

  function setupSeamlessLoop(container, videos) {
    if (videos.length < 2) return;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      videos[0].loop = true;
      videos.slice(1).forEach(function (video) {
        video.remove();
      });
      return;
    }

    var activeIndex = 0;
    var crossfading = false;

    videos.forEach(function (video, index) {
      video.loop = false;
      video.classList.toggle('is-active', index === 0);
    });

    function getInactiveIndex() {
      return activeIndex === 0 ? 1 : 0;
    }

    function crossfadeToNext() {
      if (crossfading) return;

      var current = videos[activeIndex];
      var next = videos[getInactiveIndex()];
      if (!current || !next || !current.duration) return;

      crossfading = true;

      next.currentTime = 0;
      tryPlay(next);

      next.classList.add('is-active');
      current.classList.remove('is-active');

      window.setTimeout(function () {
        current.pause();
        current.currentTime = 0;
        activeIndex = getInactiveIndex();
        crossfading = false;
      }, CROSSFADE_MS);
    }

    videos.forEach(function (video) {
      video.addEventListener('timeupdate', function () {
        if (video !== videos[activeIndex] || crossfading || !video.duration) return;

        if (video.currentTime >= video.duration - CROSSFADE_LEAD) {
          crossfadeToNext();
        }
      });
    });
  }

  function setupAutoplay(container, videos) {
    var primary = videos[0];
    if (!primary) return;

    function updatePlayback() {
      if (!isVideoVisible(primary)) return;

      videos.forEach(function (video) {
        if (video.readyState >= 2 && (video.classList.contains('is-active') || videos.length === 1)) {
          tryPlay(video);
        }
      });
    }

    videos.forEach(function (video) {
      video.addEventListener('loadeddata', updatePlayback);
      video.addEventListener('canplay', updatePlayback);
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) updatePlayback();
          });
        },
        { rootMargin: '0px', threshold: [0, 0.2, 0.5] }
      );
      observer.observe(primary);
    }

    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) updatePlayback();
    });

    updatePlayback();
  }

  function initDriverVideo(container) {
    if (!container || container.dataset.vechargeDriverVideoInit === 'true') return;

    container.dataset.vechargeDriverVideoInit = 'true';

    var videos = Array.prototype.slice.call(
      container.querySelectorAll('.vecharge-driver-features__video-element')
    );
    if (!videos.length) return;

    var shouldLoop = container.dataset.videoLoop === 'true';
    var shouldAutoplay = container.dataset.videoAutoplay === 'true';

    if (shouldLoop && videos.length > 1) {
      setupSeamlessLoop(container, videos);
    }

    if (shouldAutoplay) {
      var playbackVideos = Array.prototype.slice.call(
        container.querySelectorAll('.vecharge-driver-features__video-element')
      );
      setupAutoplay(container, playbackVideos);
    }
  }

  function initDriverVideos(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-vecharge-driver-video]').forEach(initDriverVideo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initDriverVideos(document);
    });
  } else {
    initDriverVideos(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initDriverVideos(event.target);
  });
})();
